<template>
    <Row>
        <i-col span="12">
    <Tree :data="data3" @on-select-change="updte" ></Tree>
    <Button type="primary" @click="addmenu">新增</Button>
     <Button type="primary" @click="deletemenu">删除</Button>
    </i-col>
        <i-col span='12'>
           
        <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="100">
            <Alert show-icon>{{title}}</Alert>
            <FormItem label="菜单名称" prop="name">
                <i-input v-model="formValidate.name" placeholder="请输入菜单名称"></i-input>
            </FormItem>
            <FormItem label="菜单图标" prop="icon">
              <i-input v-model="formValidate.icon"></i-input>
            </FormItem>
             <FormItem label="上级菜单">
                         <Select v-model="menu.lev1" style="width:100px" @on-change="changedata()">
                            <Option v-for="item in menudata1" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                         <Select v-model="menu.lev2" style="width:100px" @on-change="changedatab()" v-if="menu.lev1&&isshow">
                            <Option v-for="item in menudata1[myindex].submenu" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                         <Select v-model="menu.lev3" style="width:100px"   v-if="menu.lev2&&isshow1">
                            <Option v-for="item in submenu" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                         <Button type="primary" @click="menuinit()">重置</Button> 
             </FormItem>
             <FormItem label="链接地址" prop="link">
                    <i-input v-model="formValidate.link" placeholder="请输入链接地址"></i-input>
             </FormItem>
              <FormItem label="排序" prop="sort">
                    <i-input v-model="formValidate.sort" placeholder="请输入排序"></i-input>
             </FormItem>
             <FormItem label="是否显示" prop="shown">
                  <RadioGroup v-model="formValidate.shown">
                    <Radio label="1">是</Radio>
                    <Radio label="0">不是</Radio>
                </RadioGroup>
             </FormItem> 
            <FormItem>
                <Button type="primary" @click="handleSubmitn('formValidate')">提交</Button>
            </FormItem>
        </Form>
        </i-col>
    </Row>
</template>
<script>
import { mapState } from "vuex";
import {
  company_menuindex,
  company_createmenu,
  company_updatemenu,
  company_deletemenu
} from "../../api/menuapi";
export default {
  data() {
    const validatemenu_id = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请选择菜单"));
      } else {
        console.log(this.id);
        if (this.title == "编辑菜单" && !this.id) {
          callback(new Error("请选择左侧菜单进行编辑"));
        } else {
          callback();
        }
      }
    };
    return {
      data3: [
        {
          title: "菜单",
          loading: false,
          children: []
        }
      ],

      title: "编辑菜单",
      formValidate: {
        name: "",
        icon: "",
        link: "",
        sort: "",
        shown: "1",
        sup_menu_id: ""
      },
      submenu: [],
      menudata: [],
      menudata1: [],
      ruleValidate: {
        name: [{ validator: validatemenu_id, trigger: "blur" }]
      },
      myindex: 0,
      isshow: false,
      isshow1: false,
      menu: {
        lev1: "",
        lev2: "",
        lev3: ""
      }
    };
  },

  methods: {
    handleSubmitn(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (this.menu.lev1) {
            this.formValidate.sup_menu_id = this.menu.lev1;
            if (this.menu.lev2) {
              this.formValidate.sup_menu_id = this.menu.lev2;
              if (this.menu.lev3) {
                this.formValidate.sup_menu_id = this.menu.lev3;
              }
            }
          }
          if (this.title == "新增菜单") {
            this.createmenu();
          } else if (this.title == "编辑菜单") {
            this.updatemenu();
          }
        } else {
          this.$Message.error("Fail!");
        }
      });
    },
    getmenulist() {
      var par = {};
      company_menuindex(par).then(res => {
        var data = res.data;
        if (data.code == 1) {
          this.menudata = data.data;
          this.menudata1 = data.data;
          // this.$store.commit("GETmenudata", data.data);
          this.getdata();
        }
      });
    },
    getdata() {
      this.data3 = [
        {
          title: "菜单",
          loading: false,
          expand: true,
          children: []
        }
      ];
      this.menudata.forEach(element => {
        let data = {};
        if (element.submenu && element.submenu.length > 0) {
          data.children = [];
          data.data = element;
          data.title = element.name;
          data.expand = true;
          data.loading = false;
          element.submenu.forEach(item => {
            if (item.submenu && item.submenu.length > 0) {
              let mindata = {
                title: item.name,
                data: item,
                loading: false,
                children: []
              };
              item.submenu.forEach(value => {
                if (value.submenu && value.submenu.length > 0) {
                  var fordata = {
                    title: value.name,
                    famenuid: item.sup_menu_id,
                    data: value,
                    children: []
                  };
                  value.submenu.forEach(minx => {
                    fordata.children.push({
                      title: minx.name,
                      famenuid: item.sup_menu_id,
                      fxamenuid: value.sup_menu_id,
                      data: minx
                    });
                  });
                  mindata.children.push(fordata);
                } else {
                  mindata.children.push({
                    title: value.name,
                    famenuid: item.sup_menu_id,
                    data: value
                  });
                }
              });
              data.children.push(mindata);
            } else {
              data.children.push({
                title: item.name,
                data: item
              });
            }
          });
        } else {
          data.title = element.name;
          data.data = element;
        }
        this.data3[0].children.push(data);
      });
    },
    changedata() {
      this.menudata1.forEach((element, index) => {
        if (element.id == this.menu.lev1) {
          this.myindex = index;
          if (element.submenu && element.submenu.length > 0) {
            this.isshow = true;
          } else {
            this.isshow = false;
          }
        }
      });

      if (this.menu.lev2) {
        this.changedatab();
      }
    },
    createmenu() {
      let par = this.formValidate;
      company_createmenu(par).then(res => {
        this.$Loading.finish();
        var data = res.data;
        if (data.code == 1) {
          this.$Message.success(data.message);
          this.itin();
          this.menuinit();
          this.getmenulist();
        } else {
          this.$Message.error(data.message);
        }
      });
    },
    updatemenu() {
      let par = this.formValidate;
      par.id = this.id;
      company_updatemenu(par).then(res => {
        this.$Loading.finish();
        var data = res.data;
        if (data.code == 1) {
          this.$Message.success(data.message);
          this.getmenulist();
        } else {
          this.$Message.error(data.message);
        }
      });
    },
    deletemenu() {
      var _this = this;
      this.$Modal.confirm({
        title: "菜单列表",
        content: `是否删除此菜单`,
        onOk: function() {
          this.$Loading.start();
          let para = { id: _this.id };
          company_deletemenu(para).then(res => {
            let data = res.data;
            if (data.code == 1) {
              _this.$Message.success(data.message);
              _this.getmenulist();
            } else {
              _this.$Message.error(data.message);
            }
          });
        }
      });
    },
    menuinit() {
      this.formValidate.sup_menu_id = null;
      this.isshow = false;
      this.isshow1 = false;
      this.menu.lev1 = null;
      this.menu.lev2 = null;
      this.menu.lev3 = null;
    },
    addmenu() {
      this.title = "新增菜单";
      this.formValidate = {
        name: "",
        icon: "",
        link: "",
        sort: "",
        shown: "1",
        sup_menu_id: ""
      };
      this.menuinit();
    },
    //初始化表单
    itin() {
      this.formValidate = {
        name: "",
        icon: "",
        link: "",
        sort: "",
        shown: "1",
        sup_menu_id: ""
      };
    },
    changedatab() {
      var data = this.menudata[this.myindex].submenu;
      data.forEach((element, index) => {
        if (element.id == this.menu.lev2) {
          if (element.submenu && element.submenu.length > 0) {
            this.isshow1 = true;
            this.submenu = element.submenu;
          } else {
            this.isshow1 = false;
          }
        }
      });
    },
    updte(res) {
      if (res && res.length > 0) {
        var data = res[0].data;
        this.formValidate.name = data.name;
        this.formValidate.icon = data.icon;
        this.formValidate.link = data.link;
        if (data.level == 2) {
          this.menu.lev1 = data.sup_menu_id;
          this.menu.lev2 = null;
        } else if (data.level == 3) {
          this.menu.lev3 = null;
          this.menu.lev2 = data.sup_menu_id;
          this.menu.lev1 = res[0].famenuid;
        } else if (data.level == 4) {
          this.menu.lev3 = data.sup_menu_id;
          this.menu.lev1 = res[0].famenuid;
          this.menu.lev2 = res[0].fxamenuid;
        } else {
          this.formValidate.sup_menu_id = null;
          this.menu.lev1 = null;
          this.menu.lev2 = null;
        }
        this.formValidate.sup_menu_id = data.sup_menu_id;
        this.formValidate.sort = data.sort;
        this.formValidate.shown = data.shown + "";
        this.id = data.id;
        this.title = "编辑菜单";
      }
    }
  },
  mounted() {
    this.getmenulist();
  }
};
</script>
            


// WEBPACK FOOTER //
// src/pages/menu/company_menu.vue